import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryAppInfos(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-app-infos`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryAppInfo(appInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-app-infos/${appInfoId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addAppInfo(
  {
    title,
    content,
    code,
    type,
    description,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-app-infos`,
    method: 'post',
    data: {
      title,
      content,
      code,
      type,
      description,
    },
  });
}

/**
 * 更新
 * @param appInfoId
 * @param  title
 * @param  content
 * @param  code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateAppInfo(appInfoId, {
  title,
  content,
  code,
  type,
  description,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-app-infos/${appInfoId}`,
    method: 'patch',
    data: {
      title,
      content,
      code,
      type,
      description,
    },
  });
}

/**
 * 删除
 * @param appInfoId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteAppInfo(appInfoId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-app-infos/${appInfoId}`,
    method: 'delete',
  });
}

export default {};
